<div class="card gp-16 gp-md-24 gmb-24">
  <h6 class="h6-bold text-primary gmb-24 gmb-md-40">
    {{ title | translate }}
  </h6>

  <app-step-progress>
    <app-step-progress-step [active]="kitClaimed">
      <p class="l1-semibold mb-0">
        {{ 'RESULTS.CLAIMED_KIT_PROGRESS.CLAIMED' | translate }}
      </p>
      <p *ngIf="kitClaimed" class="l2-semibold text-uppercase mb-0">
        {{ kitClaimed | localDate }}
      </p>
    </app-step-progress-step>

    <app-step-progress-step [active]="kitReceived">
      <p class="l1-semibold mb-0">
        {{ 'RESULTS.CLAIMED_KIT_PROGRESS.RECEIVED' | translate }}
      </p>
      <p *ngIf="kitReceived" class="l2-semibold text-uppercase mb-0">
        {{ kitReceived | localDate }}
      </p>
    </app-step-progress-step>

    <app-step-progress-step [active]="isKitSent">
      <p class="l1-semibold mb-0">
        {{ 'RESULTS.CLAIMED_KIT_PROGRESS.SENT' | translate }}
      </p>
      <p *ngIf="isKitSent" class="l2-semibold text-uppercase mb-0">
        {{ kitSent | localDate }}
      </p>
    </app-step-progress-step>

    <app-step-progress-step [active]="kitCompleted">
      <p class="l1-semibold mb-0">
        {{ 'RESULTS.CLAIMED_KIT_PROGRESS.READY' | translate }}
      </p>
      <p *ngIf="kitCompleted" class="l2-semibold text-uppercase mb-0">
        {{ kitCompleted | localDate }}
      </p>
    </app-step-progress-step>
  </app-step-progress>

  <div class="d-flex gmt-24 gmt-md-40">
    <p class="p4-regular text-secondary mb-0 gmr-4">
      {{ 'RESULTS.CLAIMED_KIT_PROGRESS.KIT_CODE' | translate }}
    </p>
    <p class="p4-semibold text-secondary mb-0">{{ kitInProgress?.kitId }}</p>
  </div>
</div>
